import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { AccountEffects } from './accounts'
import { AesEffects } from './aes'
import { AgentEffects } from './agents'
import { BankEffects } from './banks'
import { BusinessTypeEffects } from './business-types'
import { BuyersGroupEffects } from './buyers-groups'
import { CallEffects } from './calls'
import { CarrierEffects } from './carriers'
import { ConsigneesEffects } from './consignees'
import { CountryEffects } from './countries'
import { CreditNoteViewEffects } from './credit-note-view/credit-notes-view.effects'
import { CurrencyEffects } from './currencies'
import { DealViewEffects } from './deal-view-effects.effects'
import { DepartmentEffects } from './departments'
import { DocumentOverrideEffects } from './document-overrides'
import { DocumentSetEffects } from './document-sets'
import { DocumentTemplateEffects } from './document-templates'
import { FormulaValueEffects } from './formula-values'
import { InvoiceViewEffects } from './invoice-view/invoice-view.effects'
import { ItemTypeEffects } from './item-types'
import { LocationEffects } from './locations'
import { TrackingProviderEffects } from './tracking-providers'
import { PromoTextEffects } from './promo-texts'
import { PackageTrackingEffects } from './package-trackings'
import { MacropointEffects } from './macropoint'
import { MaerskBookingEffects } from './maersk-booking'
import { MatchedOffersViewEffects } from './matched-offers-view/matched-offers-view.effects'
import { MeasureEffects } from './measures'
import { MontshipBookingEffects } from './montship-booking'
import { PackageTypeEffects } from './package-types'
import { PaymentMethodEffects } from './payment-methonds'
import { PaymentReferenceEffects } from './payment-references'
import { PrefixEffects } from './prefixes'
import { SuffixEffects } from './suffixes'
import { PricingTermEffects } from './pricing-terms'
import { ProductCategoryEffects } from './product-categories'
import { ProductSpecificationEffects } from './product-specifications'
import { ProductTypeEffects } from './product-types'
import { ProductEffects } from './products'
import { ReceiptViewEffects } from './receipt-view/receipt-view.effects'
import { SegmentViewEffects } from './segment-view/segment-view.effects'
import { ShipmentRateEffects } from './shipment-rates'
import { TemplateEffects } from './templates'
import { UnlocodeEffects } from './unlocodes'
import { UserEffects } from './users'
import { VendorCreditViewEffects } from './vendor-credit-view/vendor-credit-view.effects'
import { WeightTypeEffects } from './weight-types'
import { WrappingTypeEffects } from './wrapping-types'
import { RecipientTypeEffects } from './recipient-types'
import { EventEffects } from './events'
import { KpiMetricsEffects } from './kpi-metrics'
import { CompanyViewEffects } from './company-view/company-view.effects'

@NgModule({
  imports: [
    EffectsModule.forFeature([
      AccountEffects,
      AesEffects,
      AgentEffects,
      BankEffects,
      BuyersGroupEffects,
      MontshipBookingEffects,
      BusinessTypeEffects,
      CarrierEffects,
      ConsigneesEffects,
      CountryEffects,
      CreditNoteViewEffects,
      CurrencyEffects,
      DealViewEffects,
      DepartmentEffects,
      DocumentOverrideEffects,
      DocumentSetEffects,
      DocumentTemplateEffects,
      FormulaValueEffects,
      InvoiceViewEffects,
      ItemTypeEffects,
      LocationEffects,
      TrackingProviderEffects,
      PromoTextEffects,
      PackageTrackingEffects,
      MacropointEffects,
      MaerskBookingEffects,
      MatchedOffersViewEffects,
      MeasureEffects,
      PackageTypeEffects,
      PaymentMethodEffects,
      PaymentReferenceEffects,
      PrefixEffects,
      SuffixEffects,
      PricingTermEffects,
      ProductCategoryEffects,
      ProductEffects,
      ProductSpecificationEffects,
      ProductTypeEffects,
      ShipmentRateEffects,
      TemplateEffects,
      UnlocodeEffects,
      UserEffects,
      VendorCreditViewEffects,
      WeightTypeEffects,
      WrappingTypeEffects,
      ReceiptViewEffects,
      SegmentViewEffects,
      CallEffects,
      RecipientTypeEffects,
      EventEffects,
      KpiMetricsEffects,
      CompanyViewEffects,
    ]),
  ],
})
export class StoreModule { }
